// reducers/connect/disconnect.js

export function connectDisconnectHasErrored(state = false, action) {
  switch (action.type) {
    case 'CONNECT_DISCONNECT_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function connectDisconnectIsLoading(state = false, action) {
  switch (action.type) {
    case 'CONNECT_DISCONNECT_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function connectDisconnect(state = {}, action) {
  switch(action.type) {
    case 'CONNECT_DISCONNECT_FETCH_DATA_SUCCESS':
      return action.obj;
    default:
      return state;
  }
}